import { all } from 'redux-saga/effects';

const context = require.context('./', true, /.*/);

const sagas = [];

context.keys().forEach((key) => {
  if (!(/\.js/).test(key) && !(/index/).test(key)) {
    const object = context(key);
    const dflt = object.default;

    if (dflt) {
      sagas.push(dflt.apply());
    }
  }
});

export default function* () {
  yield all(sagas);
}



// WEBPACK FOOTER //
// ./app/sagas/index.js